// hooks/useClientDomain.js
import { useMemo } from "react";
import {
  getCurrentDomainConfig,
  isClientDomain as checkIsClientDomain,
} from "../constants/clientDomains";

export const useClientDomain = () => {
  const currentDomain = window.location.origin;

  const domainConfig = useMemo(() => {
    return getCurrentDomainConfig();
  }, []);

  const isClientDomain = useMemo(() => {
    return checkIsClientDomain();
  }, []);

  const clientOrgName = useMemo(() => {
    return domainConfig?.orgName || null;
  }, [domainConfig]);

  return {
    isClientDomain,
    clientOrgName,
    clientDomain: currentDomain,
    domainConfig,
  };
};
